<template>
  <v-row :justify="justify">
    <v-col v-if="id && enterprise.type" cols="12" xl="4">
      <v-navigation-drawer width="100%" :value="true" floating stateless>
        <v-img :aspect-ratio="4 / 3" max-height="420" contain :lazy-src="url" :src="logo" />
        <v-list>
          <v-file-input v-if="can('editar_logo_empresa')" accept="image/png, image/jpeg, image/bmp"
            placeholder="Seleccione el logo de la empresa" prepend-icon="mdi-camera" label="Logo" show-size
            :rules="[rules.size]" @change="onFileChange"></v-file-input>
        </v-list>
        <v-list v-if="can('fecha_corte')">
          <v-select v-model="form.fecha_corte" :items="items_corte_type" label="Fecha de Corte"
            @change="setFechaCorte()"></v-select>
        </v-list>
      </v-navigation-drawer>
    </v-col>
    <v-col cols="12" xl="8">
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="reset" @keydown="form.onKeydown($event)">
        <div grid-list-xl>
          <form-toolbar
            :title="title"
            :loading="form.busy"
            :disable-save="requiresSupportActivation"
            @save="save"
            @cancel="cancel"
            v-if="!id"
          />
          <v-layout :id="this.id" class="wrap form-body">
            <v-col cols="12" md="12"
              v-if="enterprise && enterprise.type != null && this.$router.currentRoute.path !== '/empresas/agregar'">
              <v-text-field v-model="form.created_at" label="Fecha de Registro" placeholder="Fecha de Registro"
                readonly />
            </v-col>
            <!-- <v-col
          cols="12"
          md="8"
          v-if="enterprise && enterprise.type != null && this.$router.currentRoute.path !== '/empresas/agregar'"
        >
          <v-checkbox
            v-model="form.favorite_dealers"
            color="amber darken-2"
            on-icon="mdi-star"
            off-icon="mdi-star-outline"
          >
            <template v-slot:label>
              <span class="font-weight-bold amber--text text--darken-3">
                Favorito Global (Todos)
              </span>
            </template>
</v-checkbox>
</v-col>
<v-col cols="12" md="12"
  v-if="enterprise && enterprise.type != null && form.favorite_dealers && this.$router.currentRoute.path !== '/empresas/agregar'">
  <v-text-field v-model="form.favorite_note_dealers" label="Nota (favorito global)"
    placeholder="Comentario visible para todos..." maxlength="500" counter="500" outlined dense clearable />
</v-col> -->
            <v-col
              v-if="!id && (needsCommunityFlag || isCommunityRuc)"
              cols="12"
            >
              <v-alert
                v-if="isCommunityRuc"
                dense
                colored-border
                border="left"
                elevation="1"
                class="community-ruc-notice mb-0"
              >
                <strong>RUC Razón Comercial Independiente habilitado.</strong>
                Puedes registrar otra empresa con una sucursal distinta.
                <div
                  v-if="occupiedBranchesLabel"
                  class="mt-1"
                >
                  Sucursales ya tomadas: <strong>{{ occupiedBranchesLabel }}</strong>
                </div>
              </v-alert>
              <v-alert
                v-else-if="requiresSupportActivation"
                dense
                colored-border
                border="left"
                elevation="1"
                class="community-ruc-notice mb-0"
              >
                <strong>Ya existe una empresa con este RUC.</strong>
                <div class="caption black--text mt-1">
                  Solicite a Soporte la activación del RUC como RUC Razón Comercial Independiente.
                </div>
                <div
                  v-if="occupiedBranchesLabel"
                  class="caption black--text mt-1"
                >
                  Sucursales ya tomadas: <strong>{{ occupiedBranchesLabel }}</strong>
                </div>
                <div class="mt-3 d-flex flex-wrap align-center">
                  <v-btn
                    depressed
                    dark
                    :color="communityRequestPending ? 'green darken-1' : themeColor"
                    :class="[
                      'mr-2 mb-2 community-ruc-request-btn',
                      { 'is-sent': communityRequestPending },
                    ]"
                    :loading="requestingCommunityRuc"
                    @click="requestCommunityActivation"
                  >
                    <v-icon left>
                      {{ communityRequestPending ? 'mdi-check-circle' : 'mdi-bell-ring' }}
                    </v-icon>
                    {{ communityRequestPending ? 'Solicitud enviada' : 'Solicitar activación' }}
                  </v-btn>
                  <v-btn
                    outlined
                    color="black"
                    class="mb-2 community-ruc-copy-btn"
                    @click="copyCommunityRequestText"
                  >
                    <v-icon left>
                      mdi-content-copy
                    </v-icon>
                    Copiar texto para correo
                  </v-btn>
                </div>
              </v-alert>
              <v-alert
                v-else
                dense
                colored-border
                border="left"
                elevation="1"
                class="community-ruc-notice mb-0"
              >
                <v-checkbox
                  v-model="form.is_community_ruc"
                  color="black"
                  hide-details
                  class="mt-0 pt-0"
                >
                  <template v-slot:label>
                    <div class="black--text">
                      <strong>Registrar como RUC Razón Comercial Independiente</strong>
                      <div class="caption black--text">
                        Ya existe una empresa con este RUC. Actívalo para crear otra con una sucursal distinta.
                      </div>
                      <div
                        v-if="occupiedBranchesLabel"
                        class="caption black--text mt-1"
                      >
                        Sucursales ya tomadas: <strong>{{ occupiedBranchesLabel }}</strong>
                      </div>
                    </div>
                  </template>
                </v-checkbox>
              </v-alert>
            </v-col>
            <v-col cols="12" md="3">
              <v-select v-model="form.ruc_type" :items="items_type" :rules="[rules.required]"
                label="Tipo de Contribuyente" placeholder="Natural o Jurídico" required :loading="loading" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="form.ruc" :rules="[rules.required, rules.rucLength, rules.rucFormat]"
                label="Número de Identificación" maxlength="20" placeholder="RUC o Cédula" required :disabled="loading"
                :loading="loading" />
            </v-col>
            <v-col cols="12" md="3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-if="can('buscar_dv')" :color="themeColor" @click="searchDV" v-on="on"
                    :loading="searching || form.busy">
                    <v-icon text>mdi-account-search</v-icon>
                  </v-btn>
                </template>
                <span>Buscar</span>
              </v-tooltip>
              <v-btn class="ml-1" color="success" :loading="form.busy" @click="save"
                v-if="id && can('editar_datos_empresa')">
                <v-icon text>
                  mdi-content-save-edit
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field v-model="form.dv" :rules="[rules.required, rules.numeric, rules.dvLength]"
                label="Dígito Verificador" maxlength="2" placeholder="99" required :loading="loading" />
            </v-col>
            <v-col cols="12" :md="id ? 4 : 5">
              <v-text-field v-model="form.name" :rules="[rules.required]" label="Razón Social"
                :placeholder="razonSocialPlaceholder" required :loading="loading" />
            </v-col>
            <v-col cols="12" :md="id ? 3 : 5">
              <v-text-field v-model="form.business_name" :rules="[rules.required]" label="Nombre Comercial"
                :placeholder="razonSocialPlaceholder" required :loading="loading" />
            </v-col>
            <v-col v-if="id" cols="12" md="3" class="d-flex align-center">
              <v-checkbox v-model="form.show_bussiness_name" label="Mostrar Nombre Comercial en PDF"
                :disabled="!can('editar_datos_empresa') || loading" />
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon class="ml-1" :color="themeColor" v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>Active esta opción para incluir el Nombre Comercial; al desactivarla, el PDF mostrará únicamente la Razón Social.</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="form.email" :rules="[rules.required, rules.emailFormat]" label="Correo Electrónico"
                placeholder="ejemplo@dominio.com" required @change="validateEmail" :loading="loading" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="form.email_associated1" :rules="[rules.emailFormatOptional]" label="Correo Asociado 1"
                placeholder="ejemplo@dominio.com" maxlength="150" :loading="loading" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="form.email_associated2" :rules="[rules.emailFormatOptional]" label="Correo Asociado 2"
                placeholder="ejemplo@dominio.com" maxlength="150" :loading="loading" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="form.branch_code" :rules="[rules.required, rules.alphanumeric, rules.codeLength]"
                label="Sucursal" maxlength="4" placeholder="0001" required :loading="loading" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="form.phone" :rules="[rules.required, rules.phoneFormat]" label="Teléfono"
                placeholder="####-#### / ######-####-####" maxlength="16" required :loading="loading" />
            </v-col>
            <v-col cols="12" md="4">
              <v-select v-model="form.cat_province_id" :items="itemsProvince" item-value="id" item-text="name"
                :rules="[rules.required]" label="Provincia" required :loading="loading" @change="getDistrito()" />
            </v-col>
            <v-col cols="12" md="4">
              <v-select v-model="form.cat_district_id" :items="itemsDistrict" item-value="id" item-text="name"
                :rules="[rules.required]" label="Distrito" required :loading="loading" @change="getCorregimiento()" />
            </v-col>
            <v-col cols="12" md="4">
              <v-select v-model="form.cat_corregimiento_id" :items="itemsCorregimiento" item-value="id" item-text="name"
                :rules="[rules.required]" label="Corregimiento" required :loading="loading" />
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field v-model="form.address" :rules="[rules.required]" label="Dirección"
                :placeholder="addressPlaceholder" maxlength="100" required :loading="loading" />
            </v-col>
          </v-layout>
        </div>
      </v-form>
    </v-col>
    <v-col cols="12" md="6" v-if="enterprise && enterprise.type != null &&
      this.$router.currentRoute.path !== '/empresas/agregar' && !loading_config && enterprises_config === 1">
      <v-btn @click="openRestoreNotificationModal" :color="themeColor">
        ¿Deseas restablecer credenciales de esta empresa, Clic Aquí?
      </v-btn>
    </v-col>
    <table class="col-md-12 my-custom-table" v-if="enterprise && enterprise.type != null &&
      this.$router.currentRoute.path !== '/empresas/agregar'">
      <thead>
        <tr>
          <th style="width: 50%;">
            Configuracion de:
          </th>
          <th style="width: 50%;">
            Acción
          </th>
        </tr>
      </thead>
      <tbody>
        <RowSetting v-if="isFEL" title="Credenciales FEL" :valueActive="form.notify_fel"
          @showModal="openModalStatusNotify" />
      </tbody>
    </table>
    <DialogStatus :dialogStatus="dialogStatusNotify" :active="form.notify_fel"
      settingDescripction="el envío de credenciales FEL" :loading="loadingNotify" :methodToggle="toggleNotify"
      :hasSubtitle="true" subtitle="No podrá deshacer esta acción." :hasEmails="true"
      @closeModal="dialogStatusNotify = false" @changeCCMails="updateCCMails" />
    <v-dialog v-model="restoreNotificationModal" max-width="860">
      <v-card>
        <v-card-title>
          Selecciona el tipo de credencial a restablecer
        </v-card-title>
        <v-card-text>
          <v-select v-model="type_notification" :items="itemRestoreNotificationTypes" :rules="[rules.required]"
            label="Tipo de Credencial" required />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error darken-1" text @click="restoreNotificationModal = false">
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" text :loading="loadingRestoreNotification" @click.prevent="restoreNotification">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex';
import { mask } from 'vue-the-mask';
import FormToolbar from '~/components/Form/Toolbar';
import RowSetting from '../../components/Enterprises/RowSetting';
import DialogStatus from '../../components/Enterprises/DialogStatus';

export default {
  components: {
    FormToolbar,
    RowSetting,
    DialogStatus,
  },
  metaInfo() {
    return { title: this.$t('enterprises') };
  },
  directives: {
    mask,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    // enterpriseId: { default: null },
  },
  data: () => ({
    form: new Form({
      dealer_id: '0',
      id: null,
      ruc: null,
      name: null,
      business_name: null,
      show_bussiness_name: false,
      dv: null,
      ruc_group_dv: '1',
      ruc_type: null,
      email: null,
      email_associated1: null,
      email_associated2: null,
      phone: null,
      address: null,
      branch_code: null,
      cat_corregimiento_id: null,
      cat_district_id: null,
      cat_province_id: null,
      fel_id: '0',
      pac_id: '0',
      dashboard: null,
      notify_fel: '0',
      notifyPAC: '0',
      notifyRecepcion: '0',
      fastEmision: 0,
      active_alerts: 0,
      batches: 0,
      mail_personalization: 0,
      apioffline: 0,
      api_mail: null,
      seller_id: null,
      fecha_corte: 0,
      active: '1',
      busy: false,
      is_community_ruc: false,
      // favorite_dealers: false,
      // favorite_note_dealers: '',
    }),
    enterprises_config: null,
    loading_config: true,
    needsCommunityFlag: false,
    isCommunityRuc: false,
    requiresSupportActivation: false,
    communityRequestPending: false,
    requestingCommunityRuc: false,
    checkingCommunityRuc: false,
    occupiedBranchCodes: [],
    cc_email: '',
    app: '',
    loadingNotify: false,
    dialogStatusNotify: false,
    url: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg',
    searching: false,
    unavailable: false,
    loading: false,
    previousSearch: '',
    itemsProvince: [],
    itemsDistrict: [],
    itemsCorregimiento: [],
    items_type: [
      { value: 1, text: 'NATURAL' },
      { value: 2, text: 'JURÍDICO' },
    ],
    items_corte_type: [
      { value: 0, text: 'No tiene Fecha Corte' },
      { value: 1, text: 'Día 1 de cada mes' },
      { value: 2, text: 'Día 2 de cada mes' },
      { value: 3, text: 'Día 3 de cada mes' },
      { value: 4, text: 'Día 4 de cada mes' },
      { value: 5, text: 'Día 5 de cada mes' },
      { value: 6, text: 'Día 6 de cada mes' },
      { value: 7, text: 'Día 7 de cada mes' },
      { value: 8, text: 'Día 8 de cada mes' },
      { value: 9, text: 'Día 9 de cada mes' },
      { value: 10, text: 'Día 10 de cada mes' },
      { value: 11, text: 'Día 11 de cada mes' },
      { value: 12, text: 'Día 12 de cada mes' },
      { value: 13, text: 'Día 13 de cada mes' },
      { value: 14, text: 'Día 14 de cada mes' },
      { value: 15, text: 'Día 15 de cada mes' },
      { value: 16, text: 'Día 16 de cada mes' },
      { value: 17, text: 'Día 17 de cada mes' },
      { value: 18, text: 'Día 18 de cada mes' },
      { value: 19, text: 'Día 19 de cada mes' },
      { value: 20, text: 'Día 20 de cada mes' },
      { value: 21, text: 'Día 21 de cada mes' },
      { value: 22, text: 'Día 22 de cada mes' },
      { value: 23, text: 'Día 23 de cada mes' },
      { value: 24, text: 'Día 24 de cada mes' },
      { value: 25, text: 'Día 25 de cada mes' },
      { value: 26, text: 'Día 26 de cada mes' },
      { value: 27, text: 'Día 27 de cada mes' },
      { value: 28, text: 'Día 28 de cada mes' },
    ],
    loadingRestoreNotification: false,
    restoreNotificationModal: false,
    type_notification: null,
    itemRestoreNotificationTypes: [
      { value: 'FEL', text: 'FEL' },
    ],
    logo: '',
    success: null,
    valid: false,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      rucLength: (v) => (!!v && v.length >= 5 && v.length <= 20) || 'El campo debe tener de 5 a 20 caracteres.',
      phoneFormat: (v) => (
        /^[0-9-]+$/.test(v) && /^(?:\d{3,4}-\d{4}|\d{6}-\d{3,4}-\d{4})$/.test(v)
      ) || 'El campo debe seguir el formato ###-####, ####-####, ######-###-#### o ######-####-####.',
      codeLength: (v) => (!!v && v.length === 4) || 'El campo debe tener de 4 caracteres alfanumericos.',
      dvLength: (v) => (!!v && (v.length === 1 || v.length === 2)) || 'El campo debe tener de 2 caracteres numéricos.',
      alphanumeric: (v) => /^[a-zA-Z0-9]*$/.test(v) || 'El campo solo permite caracteres alfanumericos.',
      numeric: (v) => /^[0-9]*$/.test(v) || 'El campo debe tener solo números',
      emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
      emailFormatOptional: (v) => !v || /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
      rucFormat: (v) => /^(([P][E][-](([-]|[0-9]){1,17})|[N][-](([-]|[0-9]){1,18})|[E][-](([-]|[0-9]){1,18})|(([-]|[0-9]){5,20}))|(((([0-9]{1})[-][A][V][-](([-]|[0-9]){1,15}))|(([0-9]{2})[-][A][V][-](([-]|[0-9]){1,14})))|((([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,15}))|(([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,14}))|([N][T][-](([-]|[0-9]){1,14}))|(([0-9]{1,2})[-][P][I][-](([-]|[0-9]){1,14}))|([P][I][-](([-]|[0-9]){1,14}))|(([0-9]){1,2}[P][I][-](([-]|[0-9]){1,14})))))$/.test(v)
        || 'El campo debe tener un formato válido.',
      size: (v) => !v || v.size < 2000000 || 'Su logo no debe exceder los 2MB de tamaño.',
    },
    buttons: [
      {
        icon: 'mdi-content-save',
        name: 'Guardar',
      },
      {
        icon: 'mdi-close',
        name: 'Cancelar',
      },
    ],
    title: 'Nueva Empresa',
    method: 'POST',
    apiURL: '/api/enterprises/store',
  }),
  computed: {
    ref() { return this.form.id; },
    enterprise() {
      return this.$store.state.profile.enterprise;
    },
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
    apiURLS() {
      return `/api/catalogs/dealers/${this.user.dealer_id}/enterprises/storeDealer`;
    },
    justify() {
      return this.id && this.enterprise.type ? 'start' : 'center';
    },
    occupiedBranchesLabel() {
      if (!this.occupiedBranchCodes || !this.occupiedBranchCodes.length) {
        return '';
      }
      return this.occupiedBranchCodes.join(', ');
    },
    dealerDisplayName() {
      if (this.user && this.user.dealer && this.user.dealer.razonSocial) {
        return this.user.dealer.razonSocial;
      }
      return 'N/D';
    },
    communityRequestEmailText() {
      const ruc = this.form.ruc || 'N/D';
      const branches = this.occupiedBranchesLabel || 'Ninguna';
      const userName = (this.user && this.user.name) ? this.user.name : 'N/D';

      return [
        'Solicito la activación del siguiente RUC como Razón Social Independiente, para registrar una sucursal distinta.',
        '',
        `RUC: ${ruc}`,
        `Sucursales ya tomadas: ${branches}`,
        `Distribuidor: ${this.dealerDisplayName}`,
        `Usuario: ${userName}`,
        '',
        'Muchas gracias.',
      ].join('\n');
    },
    isFEL() {
      if (this.app === 1 || this.app === 2) {
        return true;
      }
      return false;
    },
    razonSocialPlaceholder() {
      return process.env.VUE_APP_ENV === 'HKA'
        ? 'The Factory HKA CORP'
        : 'Electronic Business Intelligence en Panamá';
    },
    addressPlaceholder() {
      return process.env.VUE_APP_ENV === 'HKA'
        ? 'Ave. La Paz, entre calles 74A y 75. El Ingenio, Bethania. Ciudad de Panamá'
        : 'Edificio W50, C. 76 Este, Panamá';
    },
  },
  watch: {
    'form.ruc': {
      handler(value) {
        this.checkCommunityRucStatus(value);
      },
    },
    'form.cat_province_id': {
      handler() {
        this.getDistrito();
      },
    },
    'form.cat_district_id': {
      handler() {
        this.getCorregimiento();
      },
    },
  },
  async mounted() {
    if (this.id) {
      this.app = this.enterprise.type;
      window.axios.get(`/api/enterprises/${this.id}/logo/FEL`)
        .then((result) => {
          this.logo = result.data.logoBase64 ? `data:image/png;base64, ${result.data.logoBase64}` : '';
        });
      Object.assign(this.form, this.enterprise);
      this.apiURL = `/api/enterprises/${this.id}/update`;
      this.method = 'PUT';
      this.title = `Editar Empresa ${this.enterprise.ruc} - ${this.enterprise.name}`;
      this.message = `Se ha editado la empresa ${this.enterprise.name} exitosamente.`;

      await this.getDashboard().then((result) => {
        if (result.data.type === 3) {
          this.itemRestoreNotificationTypes = this.itemRestoreNotificationTypes.filter((x) => x.value !== 'FEL');
        }
        this.form.notify_fel = result.data.notify_fel;
      });
    }
    await this.getProvincia().then((response) => {
      this.itemsProvince = response.data;
    });
    try {
      const response = await this.getConfigEnterprise();
      this.enterprises_config = parseInt(response.data.enterprises_config ?? response.data, 10);
    } catch (e) {
      this.enterprises_config = 0; // o lo que decidas por defecto
    } finally {
      this.loading_config = false; // ya terminó de cargar
    }
  },
  methods: {
    getConfigEnterprise() {
      const url = `/api/catalogs/dealers/${this.user.dealer_id}/getConfig`;
      return window.axios.get(url);
    },
    checkCommunityRucStatus(ruc) {
      if (this.id || !ruc || String(ruc).length < 5) {
        this.needsCommunityFlag = false;
        this.isCommunityRuc = false;
        this.requiresSupportActivation = false;
        this.communityRequestPending = false;
        this.occupiedBranchCodes = [];
        this.form.is_community_ruc = false;
        return;
      }

      this.checkingCommunityRuc = true;
      window.axios.get(`/api/enterprises/checkCommunityRuc/${encodeURIComponent(ruc)}`)
        .then((result) => {
          this.needsCommunityFlag = !!result.data.needs_community_flag;
          this.isCommunityRuc = !!result.data.is_community;
          this.requiresSupportActivation = !!result.data.requires_support_activation;
          this.communityRequestPending = !!result.data.community_request_pending;
          this.occupiedBranchCodes = result.data.branch_codes || [];
          if (!this.needsCommunityFlag || this.requiresSupportActivation) {
            this.form.is_community_ruc = false;
          }
        })
        .catch(() => {
          this.needsCommunityFlag = false;
          this.isCommunityRuc = false;
          this.requiresSupportActivation = false;
          this.communityRequestPending = false;
          this.occupiedBranchCodes = [];
          this.form.is_community_ruc = false;
        })
        .finally(() => {
          this.checkingCommunityRuc = false;
        });
    },
    requestCommunityActivation() {
      if (this.communityRequestPending || this.requestingCommunityRuc || !this.form.ruc) {
        return;
      }

      this.requestingCommunityRuc = true;
      window.axios.post('/api/enterprises/requestCommunityRuc', { ruc: this.form.ruc })
        .then((result) => {
          this.$store.dispatch('notifications/show', {
            message: result.data.message,
            type: result.data.type,
          });
          if (result.data.type === 'success' || result.data.community_request_pending) {
            this.communityRequestPending = true;
          }
        })
        .catch(() => {
          this.$store.dispatch('notifications/show', {
            message: 'No se pudo enviar la solicitud. Intente nuevamente.',
            type: 'error',
          });
        })
        .finally(() => {
          this.requestingCommunityRuc = false;
        });
    },
    copyCommunityRequestText() {
      const text = this.communityRequestEmailText;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.$store.dispatch('notifications/show', {
              message: 'Texto copiado. Péguelo en el correo a Soporte.',
              type: 'success',
            });
          })
          .catch(() => {
            this.fallbackCopyText(text);
          });
        return;
      }
      this.fallbackCopyText(text);
    },
    fallbackCopyText(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$store.dispatch('notifications/show', {
        message: copied
          ? 'Texto copiado. Péguelo en el correo a Soporte.'
          : 'No se pudo copiar el texto. Selecciónelo manualmente.',
        type: copied ? 'success' : 'error',
      });
    },
    getDashboard() {
      const url = `/api/enterprises/${this.id}`;
      return window.axios.get(url);
    },
    searchEnterprise() {
      if (!this.form.ruc) {
        this.$store.dispatch('notifications/show', {
          message: 'Introduzca un número de identificación.',
          type: 'error',
        });
        return;
      }

      // Verifica si form.subsidiary_code no está vacío
      if (!this.form.branch_code) {
        this.$store.dispatch('notifications/show', {
          message: 'Ingrese un código de sucursal.',
          type: 'error',
        });
        return;
      }

      // Verifica si form.ruc y form.branch_code no están vacíos
      if (!this.form.ruc || !this.form.branch_code) return;

      // Verifica si los valores actuales de form.ruc y form.branch_code son iguales a los anteriores
      if (this.form.ruc === this.previousSearch && this.form.branch_code === this.previousSubsidiaryCode) return;

      // Actualiza los valores de búsqueda anteriores
      this.previousSearch = this.form.ruc;
      this.previousSubsidiaryCode = this.form.branch_code;

      this.loading = true;

      window.axios.get(`/api/enterprises/getEnterprises/${this.form.ruc}/${this.form.branch_code}`)
        .then((result) => {
          this.loading = false;
          if (result.data.type !== 'error') {
            this.unavailable = false;
            if (result.data.message) {
              if (this.type === 'warning') {
                this.unavailable = true;
              }
            } else {
              Object.assign(this.form, result.data);
            }
            this.form.branch_code = result.data.branch_code;
          } else {
            this.$refs.form.reset();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openModalStatusNotify(notifyFEL) {
      if (notifyFEL === 0) {
        this.dialogStatusNotify = true;
      }
    },
    toggleNotify() {
      this.loadingNotify = true;
      const url = `/api/enterprises/${this.id}/notify_fel`;
      window.axios.put(url, {
        notify_fel: this.form.notify_fel,
        cc_email: this.cc_email,
      })
        .then((response) => {
          this.loadingNotify = false;
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.dialogStatusNotify = false;
          if (this.form.notify_fel === 0) {
            this.form.notify_fel = 1;
          } else {
            this.form.notify_fel = 0;
          }
          this.cc_email = '';
        });
    },
    openRestoreNotificationModal() {
      this.restoreNotificationModal = true;
    },
    restoreNotification() {
      if (!this.type_notification) {
        // Manejo de error si el campo requerido no está presente
        this.$store.dispatch('notifications/show', {
          message: 'Por favor, selecciona un tipo de credencial.',
          type: 'error',
        });
        return;
      }

      this.loadingRestoreNotification = true;
      const url = `/api/enterprises/${this.id}/restore_notification`;
      window.axios.put(url, {
        type: this.type_notification,
      })
        .then((response) => {
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.loadingRestoreNotification = false;
          this.restoreNotificationModal = false;
          this.type_notification = null;

          this.getDashboard().then((result) => {
            if (result.data.type === 3) {
              this.itemRestoreNotificationTypes = this.itemRestoreNotificationTypes.filter((x) => x.value !== 'FEL');
            }
            this.form.notify_fel = result.data.notify_fel;
          });
        });
    },
    updateCCMails(ccEmails) {
      this.cc_email = ccEmails;
    },
    async validate() {
      this.form.busy = true;
      const email = await this.validateEmail();
      if (!email) {
        if (this.$refs.form.validate()) {
          this.store();
        } else {
          this.form.busy = false;
        }
      }
    },
    store() {
      this.form.dealer_id = this.user.dealer_id;
      if (this.method === 'POST') {
        this.apiURL = this.apiURLS;
      }
      window.axios({
        method: this.method,
        url: this.apiURL,
        data: this.form,
      }).then((response) => {
        if (response.data.type === 'success') {
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.searching = false;
          if (!this.id) {
            this.$router.push({ name: 'enterprises' });
          }
        } else {
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.searching = false;
        }
        if (this.newLogo) {
          const config = {
            headers: {
              'content-type': 'multipart/form-data',
            },
          };
          window.axios.post(`/api/enterprises/${this.id}/logo/store/FEL`, this.newLogo, config);
        }
      })
        .finally(() => {
          this.form.busy = false;
        });
    },
    searchDV() {
      if (this.form.ruc_type) {
        if (this.form.ruc) {
          this.searching = true;
          const url = `/api/enterprises/getDV/${this.form.ruc}/${this.form.ruc_type}`;
          window.axios.post(url)
            .then((response) => {
              if (response.data.type === 'success') {
                let messageType = 'error';
                if (response.data.message.ConsultarRucDVResult.codigo === '200') {
                  const { dv: dvResult } = response.data.message.ConsultarRucDVResult.infoRuc;
                  let dv = dvResult;
                  if (dv.length === 1) {
                    dv = `0${dv}`;
                  }
                  this.form.dv = dv;
                  this.form.name = response.data.message.ConsultarRucDVResult.infoRuc.razonSocial;
                  messageType = 'success';
                }
                this.$store.dispatch('notifications/show', {
                  message: response.data.message.ConsultarRucDVResult.mensaje,
                  type: messageType,
                });
                this.searching = false;
              } else {
                this.$store.dispatch('notifications/show', {
                  message: response.data.message,
                  type: response.data.type,
                });
                this.searching = false;
              }
            });
        } else {
          this.$store.dispatch('notifications/show', {
            message: 'Introduzca un número de identificación.',
            type: 'error',
          });
        }
      } else {
        this.$store.dispatch('notifications/show', {
          message: 'Seleccione un tipo de contribuyente.',
          type: 'error',
        });
      }
    },
    async validateEmail() {
      if (this.form.email) {
        const url = `/api/enterprises/searchEmail/${this.form.id}/${this.form.email}`;
        await window.axios.get(url)
          .then((response) => {
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            if (response.data.code === 500) {
              this.form.email = '';
              this.form.busy = false;
              return true;
            }
          });
      }
      return false;
    },
    save() {
      if (this.requiresSupportActivation) {
        this.$store.dispatch('notifications/show', {
          message: 'Ya existe una empresa con este RUC. Solicite a Soporte la activación del RUC como RUC Razón Comercial Independiente.',
          type: 'error',
        });
        return;
      }
      this.validate();
    },
    cancel() {
      this.$router.go(-1); // someValue
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    getProvincia() {
      const url = '/api/provinces';
      return window.axios.get(url);
    },
    getDistrito() {
      if (this.form.cat_province_id) {
        const url = `/api/districts/${this.form.cat_province_id}`;
        window.axios.get(url)
          .then((response) => {
            this.itemsDistrict = response.data;
          });
      }
    },
    getCorregimiento() {
      if (this.form.cat_district_id) {
        const url = `/api/corregimientos/${this.form.cat_district_id}`;
        window.axios.get(url)
          .then((response) => {
            this.itemsCorregimiento = response.data;
          });
      }
    },
    onFileChange(e) {
      this.logo = URL.createObjectURL(e);
      const formData = new FormData();
      formData.append('file', e);
      this.newLogo = formData;
    },
    setFechaCorte() {
      if (!this.id) return;
      const url = `/api/enterprises/${this.id}/updateFechaCorte`;
      window.axios.put(url, { fecha_corte: this.form.fecha_corte })
        .then((response) => {
          this.$store.dispatch('notifications/show', {
            message: response.data.message || 'Fecha de corte actualizada.',
            type: response.data.type || 'success',
          });
        })
        .catch(() => {
          this.$store.dispatch('notifications/show', {
            message: 'No se pudo actualizar la fecha de corte.',
            type: 'error',
          });
        });
    },
  },
};

</script>
<style scoped>
.community-ruc-notice {
  background: #fff3cd !important;
  border-left-color: #f0ad4e !important;
  color: #000000 !important;
  font-size: 14px;
  font-weight: 500;
}

.community-ruc-notice >>> .v-alert__content,
.community-ruc-notice >>> .v-label,
.community-ruc-notice >>> strong,
.community-ruc-notice >>> .caption {
  color: #000000 !important;
}

.community-ruc-notice >>> .community-ruc-request-btn {
  color: #ffffff !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: none;
}

.community-ruc-notice >>> .community-ruc-request-btn .v-icon,
.community-ruc-notice >>> .community-ruc-request-btn .v-btn__content {
  color: #ffffff !important;
}

.community-ruc-notice >>> .community-ruc-request-btn.is-sent {
  background-color: #2e7d32 !important;
  color: #ffffff !important;
  pointer-events: none;
  box-shadow: none;
}

.community-ruc-notice >>> .community-ruc-request-btn.is-sent .v-icon,
.community-ruc-notice >>> .community-ruc-request-btn.is-sent .v-btn__content {
  color: #ffffff !important;
  opacity: 1 !important;
}

.community-ruc-notice >>> .community-ruc-copy-btn {
  font-weight: 600;
  text-transform: none;
  background: #ffffff !important;
}

@media (min-width: 1200px) {
  .col-xl-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.3333333333%;
    flex: 0 0 33.3333333333% !important;
    max-width: 33.3333333333% !important;
  }

  .col-xl-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 66.6666666667%;
    flex: 0 0 66.6666666667% !important;
    max-width: 66.6666666667% !important;
  }
}
</style>
